import Backbone from "backbone";
import _ from "underscore";
import Uri from "jsuri";
import WebhookModel from "src/shared/webhooks/WebhookModel";

const WebhookCollection = Backbone.Collection.extend({
    url() {
        const uri = new Uri("/api/v6/webhooks");
        if (this.type) {
            uri.addQueryParam("type", this.type);
        }
        return uri.toString();
    },

    model: WebhookModel,

    initialize(attributes, options) {
        this.type = options && options.type;
    },
});

WebhookCollection.create = function (type) {
    return new WebhookCollection(null, { type });
};

export default WebhookCollection;
